module.exports = __webpack_public_path__ + "static/img/our-people-our-investment-snapshot-cell-1A.de1ed71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-our-investment-snapshot-cell-1A.jpg
// module id = nQ4M
// module chunks = 0